import { LegalLayout, H2, H3, P, Strong, UL, LI } from "@/components/legal/LegalLayout";

const LegalNoticePage = () => (
  <LegalLayout
    title="Mentions légales"
    subtitle="SelfieBooth Event · selfieboothevent.fr"
  >
    <H2>Éditeur du site</H2>
    <P><Strong>SelfieBooth Event</Strong> — Entreprise individuelle (auto-entrepreneur)<br />
      Représentée par Walid Bourahla<br />
      44B rue Gabriel Péri<br />
      78210 Saint-Cyr-l&apos;École<br />
      France
    </P>
    <P><Strong>SIRET :</Strong> 931 457 360 00010</P>
    <P><Strong>Code APE :</Strong> 74.20Z (Activités photographiques)</P>
    <P><Strong>TVA :</Strong> Non applicable — article 293 B du Code Général des Impôts (franchise en base de TVA)</P>
    <P><Strong>Contact :</Strong></P>
    <UL>
      <LI>Email : <a href="mailto:walid.societe.pro@gmail.com" style={{ color: "#B8977E" }}>walid.societe.pro@gmail.com</a></LI>
      <LI>Téléphone : 06 79 39 34 29</LI>
    </UL>

    <H2>Directeur de la publication</H2>
    <P>Walid Bourahla, en qualité de représentant légal de l&apos;entreprise individuelle SelfieBooth Event.</P>

    <H2>Hébergeur du site</H2>
    <P>
      <Strong>Emergent</Strong> — Plateforme d&apos;hébergement web (Emergent Labs)<br />
      Contact hébergeur via l&apos;espace client sur : <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" style={{ color: "#B8977E" }}>https://emergent.sh</a>
    </P>
    <P style={{ fontSize: "0.85rem", color: "#8a7a70", fontStyle: "italic" }}>
      Note : les coordonnées légales complètes de l&apos;hébergeur (adresse siège social, téléphone) sont à compléter à réception de la fiche fournisseur.
    </P>

    <H2>Propriété intellectuelle</H2>
    <P>L&apos;ensemble du contenu de ce site (textes, images, photographies, logo, vidéos, éléments graphiques, code source) est la propriété exclusive de SelfieBooth Event ou fait l&apos;objet d&apos;une autorisation d&apos;utilisation.</P>
    <P>Toute reproduction, représentation, modification, publication ou adaptation totale ou partielle, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de SelfieBooth Event.</P>
    <P>Toute exploitation non autorisée du site ou de son contenu sera considérée comme constitutive d&apos;une contrefaçon et poursuivie conformément aux articles L.335-2 et suivants du Code de la Propriété Intellectuelle.</P>

    <H3>Crédits photos</H3>
    <P>Les photographies présentées sur ce site sont la propriété de SelfieBooth Event, sauf mention contraire. Les photos d&apos;événements clients sont publiées avec leur autorisation écrite préalable.</P>

    <H2>Médiation de la consommation</H2>
    <P>Conformément aux articles L611-1 et suivants du Code de la consommation, tout consommateur a le droit de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d&apos;un litige.</P>
    <P style={{ fontSize: "0.85rem", color: "#8a7a70", fontStyle: "italic" }}>
      Médiateur désigné : information à compléter après adhésion à un dispositif de médiation agréé.
    </P>

    <H2>Droit applicable</H2>
    <P>Le présent site est soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.</P>
  </LegalLayout>
);

export default LegalNoticePage;
